import {
  AppliedFilterType,
  FilterType,
} from 'types/ProductListing/ProductListing';

const FORCE_SKU_FILTERS = ['Bonnet', 'CodeTaille', 'LibelleTaille'];

export function shouldForceSkuTargeting(
  filters: FilterType[],
  appliedFilters: AppliedFilterType[]
): boolean {
  let concernedCurrentCount = 0;
  let concernedAppliedCount = 0;

  for (const filter of filters) {
    if (FORCE_SKU_FILTERS.includes(filter.name)) {
      concernedCurrentCount++;
    }
  }

  for (const filter of appliedFilters) {
    if (FORCE_SKU_FILTERS.includes(filter.code)) {
      concernedAppliedCount++;
    }
  }

  return (
    concernedCurrentCount > 0 && concernedCurrentCount === concernedAppliedCount
  );
}

export function getSkuTargetingUrl(url: string): string {
  return url + '?selected=true';
}
